import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { NewbuildingBrokerSelfRequestFormBanner } from './NewbuildingBrokerSelfRequestFormBanner';
import { trackBannerClick, trackBannerShow } from './tracking';
import { NewbuildingBrokerFlightBanner } from '../NewbuildingBrokerFlightBanner';
import { requestAuthentication } from 'shared/actions/authentication';
import {
  setNewbuildingBrokerSelfRequestFormWidgetActive,
  setNewbuildingBrokerSelfRequestFormWidgetLoading,
} from 'shared/actions/newbuildingBrokerSelfRequestFormWidget';
import { Dispatch } from 'shared/common/state';
import {
  selectNewbuildingBrokerConsultantBannerButtonText,
  selectNewbuildingBrokerFlightEnabled,
} from 'shared/selectors/newbuildingBrokerConsultantBanner';
import { selectNewbuildingBrokerSelfRequestFormWidgetLoading } from 'shared/selectors/newbuildingBrokerSelfRequestFormWidget';
import { getUser } from 'shared/selectors/user';

export const NewbuildingBrokerSelfRequestFormBannerContainer: React.FC = () => {
  const dispatch: Dispatch = useDispatch();

  const buttonText = useSelector(selectNewbuildingBrokerConsultantBannerButtonText);
  const loading = useSelector(selectNewbuildingBrokerSelfRequestFormWidgetLoading);
  const user = useSelector(getUser);
  const isBrokerFlightEnabled = useSelector(selectNewbuildingBrokerFlightEnabled);

  const activateWidget = React.useCallback(() => {
    dispatch(setNewbuildingBrokerSelfRequestFormWidgetLoading(true));
    dispatch(setNewbuildingBrokerSelfRequestFormWidgetActive(true));
  }, [dispatch]);

  const handleButtonClick = React.useCallback(() => {
    trackBannerClick();

    if (!user.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => activateWidget,
        }),
      );

      return;
    }

    activateWidget();
  }, [dispatch, user, activateWidget]);

  if (isBrokerFlightEnabled) {
    return (
      <ActionAfterViewObserver callback={trackBannerShow}>
        <NewbuildingBrokerFlightBanner buttonText={buttonText} buttonLoading={loading} onClick={handleButtonClick} />
      </ActionAfterViewObserver>
    );
  }

  return (
    <ActionAfterViewObserver callback={trackBannerShow}>
      <NewbuildingBrokerSelfRequestFormBanner
        buttonText={buttonText}
        buttonLoading={loading}
        onClick={handleButtonClick}
      />
    </ActionAfterViewObserver>
  );
};
